import { useEffect } from 'react';

const APP_STORE_URL = 'https://app.nuraemobility.co.in/?c=YImSUF';
const PLAY_STORE_URL = 'https://app.nuraemobility.co.in/?c=YImSUF';

// /appinstall — sends user directly to the store to install the app
export default function AppInstallPage() {
  useEffect(() => {
    const ua = navigator.userAgent || navigator.vendor || window.opera;
    const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
    const isAndroid = /android/i.test(ua);

    if (isIOS) {
      window.location.replace(APP_STORE_URL);
    } else if (isAndroid) {
      window.location.replace(PLAY_STORE_URL);
    } else {
      document.title = 'Install Nura';
    }
  }, []);

  const ua = navigator.userAgent || navigator.vendor || window.opera;
  const isIOS = /iPad|iPhone|iPod/.test(ua) && !window.MSStream;
  const isAndroid = /android/i.test(ua);
  const isMobile = isIOS || isAndroid;

  if (isMobile) return null;

  // Desktop fallback UI
  return (
    <div style={{
      minHeight: '100vh',
      background: '#000',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: '32px',
      padding: '24px',
    }}>
      <img
        src="https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/279asuc7_white%20black%20logo.png"
        alt="NURA"
        style={{ height: '64px', width: 'auto' }}
      />
      <p style={{ color: '#fff', fontSize: '18px', textAlign: 'center' }}>
        Download the Nura app on your device
      </p>
      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center' }}>
        <a href={APP_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/hi2yb4wg_App%20Store.png"
            alt="Download on the App Store"
            style={{ height: '52px', width: 'auto' }}
          />
        </a>
        <a href={PLAY_STORE_URL} target="_blank" rel="noopener noreferrer">
          <img
            src="https://customer-assets.emergentagent.com/job_electric-rides-6/artifacts/bqk1ja7h_Play%20Store.png"
            alt="Get it on Google Play"
            style={{ height: '52px', width: 'auto' }}
          />
        </a>
      </div>
    </div>
  );
}
